import React from 'react';
import { Link } from 'react-router';
import logoIcon from "assets/logo.png";
import styles from './NavBar.module.css';

export default function NavBar() {
    return (
        <nav className={styles.navbar}>
            <div className={styles.container}>
                <div className={styles.logoSection}>
                    <Link to="https://sensible-vr.com" replace={true}>
                        <img src={logoIcon} alt="Logo" className={styles.logo} style={{ width: '186px' }} />
                    </Link>
                </div>
                {/* <div className={styles.navLinks}>
                    <Link className={styles.navLink} to="/library" replace={true}>
                        Library
                    </Link>
                    <Link className={styles.navLink} to="/game">
                        Image Jeopardy
                    </Link>
                </div> */}
            </div>
        </nav>
    );
}